import { Component, TemplateRef, ViewChild, NO_ERRORS_SCHEMA } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { UtilsDataService } from '../services/utils-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { VendorService } from '../services/vendor.service';
import { SnackBarService } from '../shared/services/snack-bar.service';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatNativeDateModule } from '@angular/material/core';

import { HeaderOneComponent } from '../shared/header/header-one/header-one.component';
@Component({
  standalone: true,
  selector: 'app-advertise-details-view',
  templateUrl: './advertise-details-view.component.html',
  styleUrl: './advertise-details-view.component.scss',
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatNativeDateModule, MatTabsModule, MatButtonModule, MatIconModule, MatTooltipModule, HeaderOneComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AdvertiseDetailsViewComponent {
  [key: string]: any;
  constructor() {
  }

}
